import * as React from "react";
import type { LucideIcon } from "lucide-react";

import { cn } from "@/lib/utils";

export type StatusBadgeVariant =
  | "success"
  | "warning"
  | "danger"
  | "info"
  | "neutral"
  | "softDanger";

const VARIANT_CLASS: Record<StatusBadgeVariant, string> = {
  success: "fx-badge fx-badge-success",
  warning: "fx-badge fx-badge-draft",
  danger: "fx-badge fx-badge-warn",
  info: "fx-badge fx-badge-neutral",
  neutral: "fx-badge fx-badge-neutral",
  softDanger: "fx-badge fx-badge-warn",
};

export interface StatusBadgeProps {
  variant: StatusBadgeVariant;
  children: React.ReactNode;
  className?: string;
  /** Optional Lucide icon to render before the label. Rendered at 12px to match badge type. */
  icon?: LucideIcon;
}

export function StatusBadge({
  variant,
  children,
  className,
  icon: Icon,
}: StatusBadgeProps): JSX.Element {
  return (
    <span className={cn(VARIANT_CLASS[variant], className)}>
      {Icon ? <Icon className="h-3 w-3 shrink-0" aria-hidden /> : null}
      {children}
    </span>
  );
}
